import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=2c8b71cb&"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js&"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports